import {
  BASE_SPEED,
  BASE_TURN_RATE,
  BOOST_SPARK_DROP_RATE,
  BOOST_MULTIPLIER,
  MIN_BOOST_LENGTH,
  NETCODE_V4_FIXED_DT_SECONDS,
  SEGMENT_SPACING,
  normalizeRadians,
} from '@star-snake/shared'

export interface MovementConfigV4 {
  baseSpeed: number
  baseTurnRate: number
  minBoostLength: number
  segmentSpacing: number
  boostSparkDropRate: number
}

export const DEFAULT_MOVEMENT_CONFIG_V4: MovementConfigV4 = {
  baseSpeed: BASE_SPEED,
  baseTurnRate: BASE_TURN_RATE,
  minBoostLength: MIN_BOOST_LENGTH,
  segmentSpacing: SEGMENT_SPACING,
  boostSparkDropRate: BOOST_SPARK_DROP_RATE,
}

export function limitedTurnV4(
  currentBearing: number,
  desiredHeading: number,
  maxTurnRate: number,
  dt = NETCODE_V4_FIXED_DT_SECONDS,
): number {
  const maxDelta = maxTurnRate * dt
  const diff = normalizeRadians(desiredHeading - currentBearing)
  if (Math.abs(diff) <= maxDelta) return normalizeRadians(desiredHeading)
  return normalizeRadians(currentBearing + Math.sign(diff) * maxDelta)
}

export function calculateSpeedV4(
  length: number,
  isBoosting: boolean,
  config: Pick<MovementConfigV4, 'baseSpeed' | 'minBoostLength'>,
): number {
  const lengthFactor = 1 - Math.min(length * 0.0002, 0.2)
  let speed = config.baseSpeed * lengthFactor
  if (isBoosting && length > config.minBoostLength) speed *= BOOST_MULTIPLIER
  return speed
}
